import { Row, Col } from 'antd'
import { CheckCircleTwoTone } from '@ant-design/icons'

import PropTypes from 'prop-types'
import { useTheme } from 'react-jss'
import { useFeatureEnabled } from '../../redux/slices/session'

export default function TopContent({ remoteMonitoring }) {
  const { brandSuccess } = useTheme
  return (
    useFeatureEnabled('in_office_checks') && (
      <Row>
        <Col span={4} offset={remoteMonitoring ? 4 : 10}>
          <CheckCircleTwoTone twoToneColor={brandSuccess} /> Office checks
        </Col>
        {remoteMonitoring && (
          <Col span={4}>
            <CheckCircleTwoTone twoToneColor={brandSuccess} /> Remote Monitoring
          </Col>
        )}
      </Row>
    )
  )
}

TopContent.propTypes = {
  remoteMonitoring: PropTypes.bool.isRequired,
}
